import dayjs from 'dayjs';
import { DutyCodePeriodRequest } from 'generated';

export const getPeriodsDurationInMinutes = (
  periods: DutyCodePeriodRequest[]
) => {
  return periods.reduce((acc, p) => {
    const startTime = dayjs(p.startTime);
    const endTime = dayjs(p.endTime);

    acc += endTime
      .add(startTime.isAfter(endTime) ? 1 : 0, 'day')
      .diff(startTime, 'minute');

    return acc;
  }, 0);
};
